import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import JourneyHeader from "@/components/JourneyHeader";

const LenderRejectionWait: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [timeLeft, setTimeLeft] = useState(30);
    const rejectionMessage = location.state?.message || "lender policies dosent meet";

    useEffect(() => {
        if (timeLeft <= 0) {
            navigate('/all-offers');
            return;
        }

        const timer = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft, navigate]);

    return (
        <div className="min-h-screen bg-white flex flex-col">
            <JourneyHeader />

            <main className="flex-1 flex flex-col items-center justify-center p-6 text-center">
                <div className="max-w-md w-full space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-700">
                    <div className="bg-red-50 w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-6">
                        <XCircle className="w-12 h-12 text-red-500" />
                    </div>

                    <div className="space-y-4">
                        <h1 className="text-3xl font-bold text-gray-900 font-outfit">Offer Not Approved</h1>
                        <p className="text-lg text-gray-600 leading-relaxed">
                            {rejectionMessage}
                        </p>
                    </div>


                    <div className="bg-gray-50 border border-gray-100 rounded-2xl p-8 my-8">
                        <p className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-2">Redirecting in</p>
                        <div className="text-5xl font-bold text-intellend-green">
                            {timeLeft}s
                        </div>
                    </div>

                    <p className="text-sm text-gray-400">
                        Please wait while we take you back to explore other available offers.
                    </p>
                </div>
            </main>
        </div>
    );
};

export default LenderRejectionWait;
